module.exports = __webpack_public_path__ + "static/media/Tile Image - EGO 6016-1 (1).006eebd1.jpg";